<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla="datosTabla"
      :resource="resource"
      @_funcionExtra="getObtenerDatosBandeja"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponente>
  </div>
</template>

<script>
import BandejaComponente from "../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";

export default {
  name: "bandejaEmbajadorHallazgoRechazadosPendientes",
  components: {
    BandejaComponente,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fechaFin: "",
    fechaIncio: "",
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    idPaciente: 0,
    datosTabla: [],
    encabezados: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dteFechaHerramienta",
        label: "Herramientas",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "NombrePacienteComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true, 
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel",
        sortable: true,
      }, 
      {
        key: "descripcionRespuestaM2",
        label: "Respuesta M2",
        sortable: true,
      }, 
      {
        key: "descripcionEstatusM2",
        label: "Estatus M2",
        sortable: true,
      }, 
      {
        key: "nombreTipoSolicitudAnterior",
        label: "Solicitud original",
        sortable: true,
      }, 
      {
        key: "cambiarBandeja",
        label: "Regresar a Bandeja Embajador Pti ",
        sortable: true,
        component: "BandejaEmbajadorPendienteRegresarBandejaComponente",        
      }, 
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
      }, 
    ],
    icono: "fa fa-credit-card",
    titulo: "BANDEJA",
    codigoTitulo: "BJ_01-SegM2",
    subTitulo: "Bandeja de seguimiento M2/réplicas (pendientes/rechazados) ",
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDoctorEmbajador: [],
    },
    idEstatusPestañaSeleccionada : 1,
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;
 

      this.$http
        .get(
          this.$api +
            "pti/bandeja/embajador/pendientes/obtenerDatosBandeja?fechaFinal=" +
            this.fechaFin +
            "&fechaIncio=" +
            this.fechaInicio +
            "&idEmpleado=" +
            this.idEmpleado +
            "&intIdEstuatusSolicitud=" +
            intIdEstuatusSolicitud +
            "&idClinica=" +
            this.idClinica +
            "&idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.resource.permiteCambiarDiagnosticador =
            response.data.data.blnPermiteEditar;
          this.resource.idEstatusSolicitud = intIdEstuatusSolicitud; 
          this.datosTabla = response.data.data.listaResultados;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getCifrasPorEstatus();
        });
 
    },
    getCifrasPorEstatus() {
      this.showAlert();
      this.$http
        .get(
          this.$api +
            "pti/bandeja/embajador/pendientes/cifrasPorEstatus?fechaFinal=" +
            this.fechaFin +
            "&fechaIncio=" +
            this.fechaInicio +
            "&idEmpleado=" +
            this.idEmpleado +
            "&idClinica=" +
            this.idClinica +
            "&idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[0].layoutTabla = this.encabezados;
              } 
            });
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        });
    }, //  ----------------------------
 
    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },

        
    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },



  },
  mounted() { 
    this.getObtenerDatosBandeja(1);
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
};
</script>
